import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcArrowupFillNomargin(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "8",
    fill: "none",
    viewBox: "0 0 12 8",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.55 8c-.46 0-.716-.539-.429-.903L5.571.21a.546.546 0 0 1 .858 0l5.45 6.888c.287.364.031.903-.43.903z"
  }));
}
var IcArrowupFillNomargin = createNolIcon(/*#__PURE__*/forwardRef(SvgIcArrowupFillNomargin));

export { IcArrowupFillNomargin as I };
